<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div fxFlex>
    <form [formGroup]="form"> 
      <mat-form-field class="width-100">
        <input 
          matInput
          #web_userInput
          formControlName="web_user" 
          [matAutocomplete]="web_userAC" 
          [placeholder]="'LABEL_WEB_USER' | translate"
          (focus)="!web_userAC.isOpen && getInitialValues('web_user')" 
          [required]="isRequired"
          >

        <mat-icon 
          id="id_select_web_user_delete_btn"
          matSuffix 
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          (click)="web_userInput.blur(); clearForm($event)"
          *ngIf="web_userInput.value && !disabled"
          >
        </mat-icon>

        <mat-icon 
          matSuffix 
          class="clear-input"
          svgIcon="menu-down"
          *ngIf="!web_userInput.value"
          >
        </mat-icon>

        <mat-autocomplete 
          id="id_select_web_user_dropdown"
          [displayWith]="displayFn" 
          #web_userAC="matAutocomplete" 
          (closed)="autoCmpltClosed(); web_userInput.blur()"
          (opened)="autocompleteScroll('web_user','web_userACRef','web_userACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.web_user && listData?.length == 0"
            >
            {{ 'LABEL_NO_DATA' | translate }}
          </mat-option>

          <mat-option
            [id]="'id_select_web_user_data_' + (i+1)"
            [value]="data" 
            matTooltipPosition="right"
            *ngFor="let data of listData; let i = index" 
            [matTooltip]="data.username + ' (' + data.email_address + ')'"
            >
            {{ data.username }} - {{ data.fullname }}
          </mat-option>

          <mat-option *ngIf="loading.web_user" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="form.get('web_user').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="form.get('web_user').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: 'LABEL_WEB_USER' | translate} }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>